import type { ReactNode } from "react";

export function PageHeader({ title, actions, testId }: { title: string; actions?: ReactNode; testId: string }) {
  return (
    <div className="fade-up mb-8 flex flex-col gap-5 border-b border-[#CBB898] pb-6 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <p className="eyebrow">Otium</p>
        <h1 className="screen-title mt-2" data-testid={testId}>
          {title}
        </h1>
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  );
}

export function Panel({ children, className = "", testId }: { children: ReactNode; className?: string; testId?: string }) {
  return (
    <div className={`rounded-[24px] border border-[#E7DECF] bg-white p-6 lg:p-8 ${className}`} data-testid={testId}>
      {children}
    </div>
  );
}

export function PanelLabel({ children }: { children: ReactNode }) {
  return <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#16294D]">{children}</p>;
}
